import React from 'react';
import { Pool } from '../../../components/LiquidityMiningPool';
import { LiquidityMiningPoolList } from '../../../components/LiquidityMiningPoolList';
import { LMInterface } from '../../../types/dto/Project.dto';

export const ActivePools: React.FC = () => {
  return (
    <LiquidityMiningPoolList
      title="Active pools"
      subTitle="List of active pools (new pools can take a few minutes to show up here)"
      filter={(pool: Pool): boolean => {
        return pool.start < new Date() && pool.end > new Date();
      }}
    />
  );
};
